import * as Types from 'types';

import { SEARCHABLE_TYPES } from 'features/search/types';

export { SearchResults } from './SearchResults';

export const TABS_INDEX_MAP: Record<number, string> = {
  0: SEARCHABLE_TYPES[0],
  1: SEARCHABLE_TYPES[1],
};

export const formatResultsSuffix = (list: Types.List<any>, type: string = 'Artworks') => {
  return `${list.ids.length} ${list.ids.length === 1 ? type.slice(0, -1) : type}`;
};
